import { CookieKeys, Cookies, memoize, Optional } from "@ctra/utils";

import { Base } from "./Base";

import { Enterprise } from "../../../enterprise";
import { FarmEntity } from "../../farms";

class FarmSeries extends Base {
  protected entity: Optional<FarmEntity>;

  constructor(id: number) {
    super(id);

    try {
      this.entity = Enterprise.entities.getFarm(Enterprise.store.getState(), { farmID: id });
    } catch (e) {}
  }

  getField(): Optional<string> {
    return (
      Cookies.get(CookieKeys.farmNamePreference) === "obfuscated"
        ? this.entity?.obfuscatedName
        : this.entity?.name
    ) as string;
  }
}

export { FarmSeries };
